import { render } from "./Registre-Visiteur.vue?vue&type=template&id=0cc57870&scoped=true"
import script from "./Registre-Visiteur.vue?vue&type=script&lang=js"
export * from "./Registre-Visiteur.vue?vue&type=script&lang=js"

import "./Registre-Visiteur.vue?vue&type=style&index=0&id=0cc57870&scoped=true&lang=css"

import exportComponent from "C:\\dev\\vue-registre-affichage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc57870"]])

export default __exports__